var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnAnnouncement = function SvgIcnAnnouncement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.494 6.43H4.75c-.38 0-.746.15-1.015.414a1.4 1.4 0 0 0-.42.998v2.824c0 .374.15.733.42.998s.635.414 1.015.414h.718V14.9a.7.7 0 0 0 .21.5.724.724 0 0 0 .508.206h1.436c.19 0 .373-.074.508-.207a.7.7 0 0 0 .21-.499v-2.823h2.154l3.59 2.823V3.607l-3.59 2.824Zm6.82 2.824c0 1.207-.689 2.301-1.794 2.824V6.43a3.141 3.141 0 0 1 1.794 2.823Z",
    fill: "#292525"
  })));
};
export default SvgIcnAnnouncement;